import React from 'react'
import ClearIcon from '@mui/icons-material/Clear';

const WorkLinePlaceUserList = ({ users, deleteUser, isCanDelete }) => {
  return (
    <>
        {
            users && users.length > 0 ?
                <div className='workLinePlaceGroup__userList'>
                    {
                        users.map((user, item) => {
                            return (
                                <div
                                    key={user.id}
                                >
                                    <p>{item + 1}</p>
                                    <p>{user.surname} {user.name}</p>
                                    {
                                        isCanDelete ?
                                            <p 
                                                onClick={e => deleteUser(user.id)}
                                                className='workLinePlaceGroup__userList-delete-ico'
                                            >
                                                <ClearIcon />
                                            </p>
                                        : ''
                                    }
                                </div>
                            )
                        })
                    }
                </div>
            : ''
        }
    </>
  )
}

export default WorkLinePlaceUserList